import React, { useState } from 'react';
import { Button as ANTButton, Form, notification, Segmented, Switch } from 'antd';
import { Button } from '../../../components/Atom/Button';
import Input from 'components/Atom/Input';
import Select from 'components/Atom/Select';
import http from '../../../utils/http';
import { getUsersRole, TimezoneNames, CurrencyNames, StoreBlockListOptions } from 'utils/services';
import { CURRENCIES } from 'utils/currencies';
import { TIMEZONES } from 'utils/constant';
import { canAccessRoute } from 'utils/featureAccess';
import { BlockList } from 'pages/XShield';
import { isShopifyBinDiscountRealmBypass } from 'utils/binDiscountAccess';

const EditStore = ({ handleOpen, updateState, store }) => {
  const { _id, name, image, email_id, activated, ecommerceChannel, isAmexCardAllowed, isPayPakCardAllowed, isGPayAllowed, googleMerchantId } = store ?? '';
  // const [createToggle, setCreateToggle] = useState(store?.settings?.order_create_email ?? false);
  // const [paidToggle, setPaidToggle] = useState(store?.settings?.order_paid_email ?? false);
  const [binDiscount, setBinDiscount] = useState(store?.settings?.bin_discount ?? true);
  const [fraudRules, setFraudRules] = useState(store?.settings?.fraud_rules ?? false);
  const [blockFraudUser, setBlockFraudUser] = useState(store?.settings?.block_fraud_user ?? false);
  const [loading, setLoading] = useState(false);
  const [value, setValue] = useState(true);
  const { isPermissionToAddLogo } = getUsersRole();
  const [timezone, setTimezone] = useState(TIMEZONES.PKT);
  const [settings, setSettings] = useState({
    background: store?.settings?.backdrop?.color?.background ?? '#1f2937',
    text: store?.settings?.backdrop?.color?.text ?? null,
    button_color: store?.settings?.button?.color?.background ?? null,
    meta_pixel_id: store?.settings?.meta_pixel_id ?? null,
    // one_tap_payments: store?.settings?.one_tap_payments ?? false,
    currency: store?.settings?.currency ?? CURRENCIES?.PKR?.code,
    fraud_rules: store?.settings?.fraud_rules ?? false,
    block_fraud_user: store?.settings?.block_fraud_user ?? false,
    block_list_fields: store?.settings?.block_list_fields ?? null,
  });
  const showBinDiscountUi = (ecommerceChannel?.type !== 'shopify-public-app' && ecommerceChannel?.type !== 'shopify-cc-app') || isShopifyBinDiscountRealmBypass();
  const initialValues = { name, activated, image, email_id, isAmexCardAllowed, isPayPakCardAllowed, isGPayAllowed, googleMerchantId, ...store?.settings };
  const onSettingChange = (key, value) => {
    setSettings((pre) => ({ ...pre, [key]: value }));
  };
  const handleTimezone = (e) => {
    setTimezone(e.value);
  };
  const onSubmit = async (payload) => {
    setLoading(true);
    try {
      const { name, image, email_id, poweredByLogo, activated, timezone, isAmexCardAllowed, isPayPakCardAllowed, isGPayAllowed, googleMerchantId, block_list_fields } = payload;
      let blocklistFields;
      if (block_list_fields) {
        blocklistFields = block_list_fields?.map((item) => (typeof item === 'string' ? item : item?.value));
      }
      const body = {
        activated,
        isAmexCardAllowed,
        isPayPakCardAllowed,
        isGPayAllowed,
        googleMerchantId,
        name,
        image: image || null,
        email_id,
        poweredByLogo: poweredByLogo?.value,
        settings: {
          backdrop: {
            color: {
              background: String(settings?.background || null),
              text: settings?.text,
            },
          },
          button: {
            text: null,
            color: {
              background: String(settings?.button_color || null),
            },
          },
          // order_create_email: createToggle,
          // order_paid_email: paidToggle,
          bin_discount: binDiscount,
          meta_pixel_id: settings?.meta_pixel_id || null,
          timezone: timezone?.value || TIMEZONES.PKT,
          // one_tap_payments: settings?.one_tap_payments,
          currency: settings?.currency || CURRENCIES?.PKR?.code,
          fraud_rules: fraudRules,
          block_fraud_user: blockFraudUser,
          block_list_fields: blocklistFields ?? [],
        },
      };

      const res = await http.put(`/stores/${_id}`, body);
      setLoading(false);
      notification.success({ message: 'DATA EDIT SUCCESSFULLY', placement: 'bottomRight' });
      updateState(res?.data?.data ?? '');
      handleOpen();
    } catch (err) {
      setLoading(false);
      console.log(err);
      notification.error({ message: err?.response?.data?.message || 'DATA NOT UPDATE', placement: 'bottomRight' });
    }
  };
  const poweredByData = [
    {
      label: 'XStak Logo',
      value: 'XStak',
    },
    {
      label: 'HBL Logo',
      value: 'hbl',
    },
  ];
  const options = [
    {
      label: 'Live',
      value: true,
    },
    {
      label: 'Test',
      value: false,
    },
  ];
  return (
    <Form layout='vertical' initialValues={initialValues} onFinish={onSubmit} method='post'>
      <Form.Item
        name='name'
        label='Brand Name'
        className='modal-field'
        rules={[
          {
            required: true,
            message: 'Store Name is required',
          },
        ]}>
        <Input placeholder='Enter Store Name' name='name' disabled />
      </Form.Item>
      <Form.Item
        name='email_id'
        label='Email ID'
        className='modal-field'
        rules={[
          {
            required: true,
            message: 'Email Id is required',
          },
        ]}>
        <Input placeholder='Enter email id' type={'email'} name='email_id' />
      </Form.Item>
      <Form.Item name='image' className='modal-field' label='Brand Image'>
        <Input placeholder='Enter Brand Image URL' type={'url'} name='image' />
      </Form.Item>
      {isPermissionToAddLogo && (
        <Form.Item label='Powered By Logo' className='modal-field' name={'poweredByLogo'}>
          <Select defaultValue={store?.poweredByLogo ?? 'XStak'} optionsValue={poweredByData} />
        </Form.Item>
      )}
      <Form.Item name='googleMerchantId' className='modal-field' label='Google Merchant Id'>
        <Input placeholder='Enter google merchant id' />
      </Form.Item>
      <Form.Item name='meta_pixel_id' className='modal-field' label='Meta Pixel ID'>
        <Input
          placeholder='Enter Meta Pixel ID to track purchase'
          type={'text'}
          name='meta_pixel_id'
          value={settings.meta_pixel_id}
          onChange={(e) => onSettingChange('meta_pixel_id', e.target.value)}
        />
      </Form.Item>
      <Form.Item className='customSelectLink select-sm  modal-field' name='timezone' label='Timezone'>
        {<Select handleChange={handleTimezone} defaultValue={timezone} optionsValue={TimezoneNames} />}
      </Form.Item>
      <Form.Item className='customSelectLink select-sm  modal-field' label='Reporting Currency'>
        {<Select showSearch handleChange={(e) => onSettingChange('currency', e.value)} defaultValue={settings?.currency} optionsValue={CurrencyNames} />}
      </Form.Item>
      <Form.Item name='bg_color' label='Background Color (Checkout Page)' className='input-color-mobile modal-field'>
        <div className='flex inputBtn'>
          <Input type='color' name='bg_color' value={settings.background} onChange={(e) => onSettingChange('background', e.target.value)} />
          <ANTButton className='restBtn' onClick={() => onSettingChange('background', '#1f2937')}>
            Reset
          </ANTButton>
        </div>
      </Form.Item>
      <Form.Item name='fg_color' label='Button Forground Color' className='input-color-mobile modal-field'>
        <div className='flex inputBtn'>
          <Input type='color' value={settings?.text} onChange={(e) => onSettingChange('text', e.target.value)} name='fg_color' />
          <ANTButton className='restBtn' onClick={() => onSettingChange('text', '#ffffff')}>
            Reset
          </ANTButton>
        </div>
      </Form.Item>
      <Form.Item name='button_color' label='Button Background Color' className='input-color-mobile modal-field'>
        <div className='flex inputBtn'>
          <Input type='color' value={settings?.button_color} onChange={(e) => onSettingChange('button_color', e.target.value)} name='button_color' />
          <ANTButton className='restBtn' onClick={() => onSettingChange('button_color', '#000000')}>
            Reset
          </ANTButton>
        </div>
      </Form.Item>
      <div className='checkoutButton'>
        {showBinDiscountUi && (
          <Form.Item name='bin_discount' className='modal-field' label='Bin Discount'>
            <Switch checked={binDiscount} onClick={() => setBinDiscount(!binDiscount)} name='bin_discount' />
          </Form.Item>
        )}
        {/* <Form.Item name='one_tap_payments' className='modal-field' label='1-Tap Payments'>
          <Switch checked={settings?.one_tap_payments} onClick={() => onSettingChange('one_tap_payments', !settings?.one_tap_payments)} name='one_tap_payments' />
        </Form.Item> */}
        <Form.Item name='isAmexCardAllowed' className='modal-field' label='AMEX Card'>
          <Switch defaultChecked={isAmexCardAllowed} />
        </Form.Item>
        <Form.Item name='isPayPakCardAllowed' className='modal-field' label='PayPak Card'>
          <Switch defaultChecked={isPayPakCardAllowed} />
        </Form.Item>
        <Form.Item name='isGPayAllowed' className='modal-field' label='Google Pay'>
          <Switch defaultChecked={isGPayAllowed} />
        </Form.Item>
      </div>
      <div className='checkoutButton'>
        {canAccessRoute(store, 'XShield') && (
          <Form.Item name='fraud_rules' className='modal-field' label='Fraud Rules'>
            <Switch checked={fraudRules} onClick={() => setFraudRules(!fraudRules)} name='fraud_rules' />
          </Form.Item>
        )}

        {canAccessRoute(store, 'XShield') && fraudRules && (
          <Form.Item name='block_fraud_user' className='modal-field' label='Block Fraudulent User'>
            <Switch checked={blockFraudUser} onClick={() => setBlockFraudUser(!blockFraudUser)} name='block_fraud_user' />
          </Form.Item>
        )}
      </div>
      {canAccessRoute(store, 'XShield') && fraudRules && blockFraudUser && (
        <Form.Item
          className='modal-field blocklist-height'
          label='Block List fields'
          name={'block_list_fields'}
          rules={[
            {
              required: true,
              message: 'BlockList field required',
            },
          ]}>
          <Select mode='multiple' placeholder={'Select Blocklist fields'} allowClear={true} optionsValue={StoreBlockListOptions} />
        </Form.Item>
      )}
      <Form.Item name='activated' className='modal-field' label='Account Mode'>
        <Segmented options={options} className='customSegment' value={value} onChange={setValue} />
      </Form.Item>
      <Form.Item>
        <div className='flex mobile-btn'>
          <ANTButton className='rounded-lg' block onClick={() => handleOpen()}>
            Cancel
          </ANTButton>
          <Button type='primary' block className='primaryBtn ml-4' htmlType='submit' loading={loading}>
            Update
          </Button>
        </div>
      </Form.Item>
    </Form>
  );
};

export default EditStore;
